import { observer } from 'mobx-react';
import { FC } from 'react';
import { PreviousOrderModalProduct } from '../../components/PreviousOrderModalProduct/PreviousOrderModalProduct';
import { PreviousOrderModalProductSkeleton } from '../../components/PreviousOrderModalProductSkeleton/PreviousOrderModalProductSkeleton';
import { previousOrderModalStore } from '../../store/previousOrderModalStore';
import { emptyArray } from 'src/utils/helpers';

export const PreviousOrderModalProducts: FC = observer((): JSX.Element | null => {
  const { loading, order } = previousOrderModalStore;

  if (!loading && !order?.products?.length) return null;

  return (
    <div className="d-flex flex-column gap-20">
      {loading
        ? emptyArray().map((_, index) => <PreviousOrderModalProductSkeleton key={`product-${index}`} />)
        : order?.products?.map((product, index) => <PreviousOrderModalProduct key={`product-${product.id}-${index}`} product={product} />)}
    </div>
  );
});
